import { isMacOS } from '@tiptap/core';

export const FORM_FIELD_NODE_NAME = 'form-field';

export const FORM_FIELD_LINE_NODE_NAME = 'form-field-line';

export const FORM_FIELD_CLASS_NAME = 'form-field';

export const FORM_FIELD_LINE_CLASS_NAME = 'form-field-line';

// The keys Tiptap's core keymap binds to Backspace and to Delete.
export const BACKSPACE_KEYS = [
  'Backspace',
  'Mod-Backspace',
  'Shift-Backspace',
  ...(isMacOS() ? ['Ctrl-h', 'Alt-Backspace'] : []),
];

export const DELETE_KEYS = [
  'Delete',
  'Mod-Delete',
  ...(isMacOS() ? ['Ctrl-d', 'Ctrl-Alt-Backspace', 'Alt-Delete', 'Alt-d'] : []),
];
